<template>
	<v-dialog v-model="dialog" max-width="50vw" persistent>
		<v-card>
			<v-toolbar><v-toolbar-title>
        		ASSIGN EMPLOYEE TO A ROOM
        	</v-toolbar-title></v-toolbar>
        	<v-card-title class="body-2" color="black">
         		<v-layout column class="pl-4 pt-2">
         			<v-flex class="title">{{payload.name}}</v-flex>
         			<v-flex>{{payload.title}}</v-flex>
         			<v-flex class="pl-4 mt-3 pr-5">
         				<v-autocomplete outline
		 					class="mt-2"
							ref="autocomplete"
							v-model="selectedBuilding"
							v-on:click=""
							
							hide-no-data
							auto-select-first
							autocomplete
							clearable
							style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
							:items="buildings"
							:filter="customFilter"
							label="Select Building (Name / Number / Addr)"
							single-line
							>
							<template
						        slot="selection"
						        slot-scope="{ item, tile }"
						      >
						      	<v-layout v-if="selectedBuilding" v-on:click="selectedBuilding = null">
						        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
						        	{{item.bldgAlpha}}
						        </v-list-tile-avatar>
						        <v-list-tile-content>
						          <v-list-tile-title>
						          	{{item.name}}
						          </v-list-tile-title>
						          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
						        </v-list-tile-content>
						    	</v-layout>
						      </template>
							<template
						        slot="item"
						        slot-scope="{ item, tile }"
						      >
						        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
						        	{{item.bldgAlpha}}
						        </v-list-tile-avatar>
						        <v-list-tile-content>
						          <v-list-tile-title>
						          	{{item.name}}
						          </v-list-tile-title>
						          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
						        </v-list-tile-content>
						      </template>
						</v-autocomplete>
					</v-flex>
					<v-flex xs1 class="pl-4 pr-5">
						<v-layout align-center v-if="showLoading && !buildingRooms">
							<!-- v-if="showLoading && !buildingRooms" -->
							<v-flex shrink ><span >Loading Rooms...</span></v-flex>
							<v-flex class="pl-5"><v-progress-linear class="ml-2 mt-0" color="blue" 		indeterminate></v-progress-linear></v-flex>
						</v-layout>
		  				<v-autocomplete outline
				  			v-if="buildingRooms"
			            	label="Select Room"
			            	single-line
			            	clearable
			            	return-object
			            	item-text="number"
			            	v-model="selectedRoom"            	
			            	:items="roomItems">
		            	</v-autocomplete>
	            </v-flex>
         		<v-flex class="pl-4 pr-5">
         			<v-autocomplete outline
				  			v-if="room"
			            	label="Select Dept"
			            	single-line
			            	clearable
			            	auto-select-first
			            	return-object
			            	v-model="selectedDept"            	
			            	item-text="deptName"
			            	:items="room.PCT">
		            	</v-autocomplete>
				</v-flex>
				<v-flex class="pl-4 pr-5">
         			<v-autocomplete outline
				  			v-if="selectedDept"
			            	label="Select Type"
			            	single-line
			            	clearable			            	
			            	auto-select-first
			            	v-model="occupantOrPI"            	
			            	:items="['Occupant', 'Principal Investigator']">
		            	</v-autocomplete>
				</v-flex>
<!-- 				{{selectedBuilding}}
				{{selectedDept.key}}
				{{occupantOrPI}} -->

         		</v-layout>
         	</v-card-title> 
        	<v-card-actions>
	          	<v-spacer></v-spacer>
	          	<v-btn color="green darken-1" flat @click.native="cancel">Cancel</v-btn>
	          	<v-btn v-if="selectedDept" color="green darken-1" flat @click.native="submit">
	          		SUBMIT
	          	</v-btn>
	        </v-card-actions>
			

		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
data () {
	return {
				showLoading: false,
				selectedDept: null,
				occupantOrPI: null,
	}
},

props: [ 'addEmployeeToRoomPayload', ],

computed: {
	...mapState({   	buildings: state => state.space.buildings,
						building: state => state.dv.building,
						buildingRooms: state => state.dv.buildingRooms,
						room: state => state.dv.room,
				}),

	dialog: {
        get () {
          return this.$store.state.ui.showAddEmployeeToRoomDialog
        },
        set (value) {
            this.setShowAddEmployeeToRoomDialog(value)
        }
    },


    selectedBuilding : {
	    get () {
	    	return this.building ? this.building.bldgAlpha : null
	    },

	    set (value) {	
	    	//console.log("AutoComplete Value: ", value)
	    	if (value) {
	    		this.getBuilding(value, "no_room_route")
	    	}	
	    	this.showLoading = true    	
	    }
	},

	 selectedRoom : {
	    get () {
	    	return this.$store.state.dv.room ? this.$store.state.dv.room : null
	    },
	    set (value) {
	        this.fetchFullRoom({bldgAlpha: this.building.bldgAlpha, number: value, noSet: true}).then((data) => { 
				this.setRoom(data) 
				this.loading = false
			})
	    }
	},

	roomItems : function () {
	  return this.buildingRooms && this.buildingRooms.map((room) => {return room.number})
	},

    payload: function () { return this.addEmployeeToRoomPayload}  // prop name is long, this is convenience.
},

methods : {
	...mapMutations([ 	'setShowAddEmployeeToRoomDialog', 'setdvBuildingRooms', 'setRoom'
					]),

	...mapActions([ 	'refreshBuilding', 'fetchFullRoom', 'setRoom', 'insertOccupant', 'insertPI']),

	getBuilding: function (bldgAlpha, no_room_route) {
		
		this.refreshBuilding(bldgAlpha).then(() => {
			if (!no_room_route && this.$route.params.room) { this.getRoom(bldgAlpha, this.$route.params.room) }
		})

		this.setdvBuildingRooms(null)
	},

	cancel: function () {		
		this.refreshBuilding(null)  // resets building, buildingrooms, and room
		this.showLoading = null		
		this.selectedDept = null
		this.occupantOrPI = null
		this.dialog = false			// this line must always be last, it ends code execution.
	},

	submit: function () {
		// Create insert Occupant/PI Payload
		let submitPayload = {	key: this.selectedDept.key,				//rmpct Key
								employeeID: this.payload.employeeID
							}

		if (this.occupantOrPI == 'Occupant') 				{ this.insertOccupant(submitPayload) 	}
		if (this.occupantOrPI == 'Principal Investigator') 	{ this.insertPI(submitPayload) 			}

		console.log("submitPayload", submitPayload)
		this.$emit('refresh')
		this.cancel()  // reset everything
	},

	customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
        const bldgAlpha = item.bldgAlpha.toLowerCase()
        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
        					item.commonName + item.shortName + item.aliasName

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3 ) {
        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        } else {
        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
        }
    },
},
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/forms/AddEmployeeToRoom.vue